import LogoutLogo from '@assets/images/ambassdor/dashboard/log-out.svg'
import { NEW_PROGRAM_PROFILE, PROFILE_TABS } from './enum'
import student_image from '@assets/images/ambassdor/OnboardingFlow/student.webp'
import business_image from '@assets/images/ambassdor/OnboardingFlow/business.webp'
import professional_image from '@assets/images/ambassdor/OnboardingFlow/professional.webp'
import school_image from '@assets/images/ambassdor/OnboardingFlow/school.webp'
import college_image from '@assets/images/ambassdor/OnboardingFlow/college.webp'

import medical_image from '@assets/images/ambassdor/OnboardingFlow/medical.webp'
import engineering_image from '@assets/images/ambassdor/OnboardingFlow/engineering.webp'
import other_fields_image from '@assets/images/ambassdor/OnboardingFlow/otherFields.webp'

import postgraduate_image from '@assets/images/ambassdor/OnboardingFlow/postgraduate.webp'
import advan_medical_image from '@assets/images/ambassdor/OnboardingFlow/advanMedical.webp'
import other_courses_image from '@assets/images/ambassdor/OnboardingFlow/otherCourses.webp'
import shop_business_image from '@assets/images/ambassdor/OnboardingFlow/shopBusiness.webp'
import diff_business_image from '@assets/images/ambassdor/OnboardingFlow/diffBusiness.webp'
import calendarImg from '@assets/images/calendar.png'
import phoneImg from '@assets/images/phoneIcon.png'

import { saathiTypeList } from './constants'
import { ProfileMapping, SublayersMapping } from './types'

export const items = [
  { name: 'Last 30 Days', key: 'Last 30 Days' },
  { name: 'Last Months', key: 'Last Months' },
  { name: 'Last Year', key: 'Last Year' },
  { name: 'Current Year', key: 'Current Year' },
  { name: 'Last Week', key: 'Last Week' },
  { name: 'Last 7 days', key: 'Last 7 days' },
  { name: 'Today', key: 'Today' },
  { name: 'Yesterday', key: 'Yesterday' },
  { name: 'Custom Calender', key: 'Custom Calender' },
]

export const filteritems = [
  'Last 30 Days',
  'Last Months',
  'Last Year',
  'Current Year',
  'Last Week',
  'Last 7 days',
  'Today',
  'Yesterday',
  'Custom Calender',
]

export const paymentWrapperItems = [
  { name: 'Pending', key: 'Pending' },
  { name: 'Successful', key: 'Successful' },
  { name: 'Failed', key: 'Failed' },
]

export const ProfileDropDownItems = [
  {
    name: 'Logout',
    key: 'Logout',
    icon: `${LogoutLogo}`,
    hoverColor: '#009898',
  },
]
export const LANDING_PAGE = {
  CONTACT: 'CONTACT',
  EARN: 'EARN',
  FAQ: 'FAQ',
  TESTIMONIAL: 'TESTIMONIAL',
  STEPS: 'STEPS',
  PRESENCE: 'PRESENCE',
  HOW_IT_WORKS: 'HOW_IT_WORKS',
}

export const landingPageHeaderItems = [
  {
    name: 'Earning Calculator',
    type: LANDING_PAGE.EARN,
  },
  {
    name: 'Testimonials',
    type: LANDING_PAGE.TESTIMONIAL,
  },
  {
    name: 'FAQ',
    type: LANDING_PAGE.FAQ,
  },
]

export const IntroductData = [
  { id: 1, title: 'Introduction to PW Ambassador' },
  { id: 2, title: 'Introduction to PW Ambassador' },
  { id: 3, title: 'Introduction to PW Ambassador' },
  { id: 4, title: 'Introduction to PW Ambassador' },
  { id: 5, title: 'Introduction to PW Ambassador' },
  { id: 6, title: 'Introduction to PW Ambassador' },
]

export const optionsForFilterDropdown: any = {
  mode: 'range',
  inline: true,
  monthSelectorType: 'static',
  dateFormat: 'M j, Y',
  prevArrow:
    '<svg class="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M5.4 10.8l1.4-1.4-4-4 4-4L5.4 0 0 5.4z" /></svg>',
  nextArrow:
    '<svg class="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M1.4 10.8L0 9.4l4-4-4-4L1.4 0l5.4 5.4z" /></svg>',
  minDate: new Date('01-01-2000'),
  maxDate: new Date(),
}

export const PROFILE_HEADER = [
  {
    name: 'Personal Details',
    key: PROFILE_TABS.PERSONAL,
  },
  {
    name: 'Program Details',
    key: PROFILE_TABS.PROGRAM,
  },
  {
    name: 'Payment Details',
    key: PROFILE_TABS.PAYMENT,
  },
]

export const btnType = [
  {
    type: 'Submit',
  },
]

export const PAYMENT_STATUS_MSG = {
  headingOne: 'Payment Details',
  headingTwo: 'Payment Details Updated',
  titleOne: 'Update your payment details to generate a coupon',
  titleTwo: 'You will receive payments in your submitted bank account',
  titleForSaathi: 'Update your payment details to start uploading leads',
}

export const EMAIL_STATUS_MSG = {
  verifyEmail: 'Verify your email address',
  emailVerified: 'Email Address Verified',
  brifMsg: 'Update your email to receive notifications.',
}

export const NOTIFICATION_DATA = {
  titleOne: 'Your profile is currently under review',
  infoOne: `Until your application is approved, you won’t be able to generate a coupon.`,
  titleTwo: 'Your application is approved!',
  infoTwo: `You can start promoting courses by generating your coupon code.`,
  infoSaathiApprove: `You can start uploading leads to earn commission.`,
  titleSaathiNotAppr: `Your Profile is currently under review.`,
  infoSaathiNotAppr: `Until your application is approved, you won’t be able to upload leads.`,
}
export const descriptionTypes = [
  {
    title: `I'm a student`,
    refers: '',
    type: 'student',
    image: `${student_image}`,
  },
  {
    title: `I'm a business owner`,
    refers: '',
    type: 'business',
    image: `${business_image}`,
  },
  {
    title: `I'm a working professional`,
    refers: '(Educator, Blogger, etc.)',
    type: 'professional',
    image: `${professional_image}`,
  },
]

export const studentDetails = [
  {
    title: `I'm in school`,
    refers: '',
    type: 'school',
    image: `${school_image}`,
  },
  {
    title: `I'm in college`,
    refers: '',
    type: 'college',
    image: `${college_image}`,
  },
]

export const collegeDetails = [
  {
    title: `Medical`,
    refers: `(MBBS, MD/MS)`,
    type: 'medical',
    image: `${medical_image}`,
  },
  {
    title: `Engineering`,
    refers: '',
    type: 'engineering',
    image: `${engineering_image}`,
  },
  {
    title: `Other Fields`,
    refers: `(Law, Arts, Commerce,etc)`,
    type: 'otherFields',
    image: `${other_fields_image}`,
  },
]

export const medicalDetails = [
  {
    title: `Undergraduate`,
    refers: '',
    type: 'undergraduate',
    image: `${college_image}`,
  },
  {
    title: `Postgraduate`,
    refers: '',
    type: 'postgraduate',
    image: `${postgraduate_image}`,
  },
]

export const undergraduateDetails = [
  {
    title: `Advanced Medical Courses`,
    refers: `(NEET-PG)`,
    type: 'advan_medical',
    image: `${advan_medical_image}`,
  },
  {
    title: `Other courses`,
    refers: `(IIT, NEET-UG, UPSC, GATE, MBA)`,
    type: 'other_courses',
    image: `${other_courses_image}`,
  },
]

export const businessDetails = [
  {
    title: `Yes, I own a physical shop`,
    refers: '',
    type: 'shop_business',
    image: `${shop_business_image}`,
  },
  {
    title: `No, I run a different business `,
    refers: `(services, online, consulting, etc.)`,
    type: 'diff_business',
    image: `${diff_business_image}`,
  },
]

export const headlingTitle = (sublayers: string) => {
  switch (sublayers) {
    case NEW_PROGRAM_PROFILE.STUDENT:
      return {
        headingTitle: ` Are you currently studying in school or college?`,
      }
    case NEW_PROGRAM_PROFILE.COLLEGE:
      return {
        headingTitle: `What type of course are you currently studying?`,
        subTitle: `Pick the one that best describes your field of study or future goals`,
      }
    case NEW_PROGRAM_PROFILE.MEDICAL:
      return {
        headingTitle: `Which stage of your medical studies are you in?`,
      }
    case NEW_PROGRAM_PROFILE.UNDER_GRADUATE:
      return {
        headingTitle: `Which types of courses would you prefer to promote?`,
      }
    case NEW_PROGRAM_PROFILE.BUSINESS:
      return { headingTitle: `Do you own a physical shop or store?` }

    default:
      return { headingTitle: `What best describes you right now?` }
  }
}

export const YOURSELF_DATA = {
  title: `You’re All Set!`,
  description: `You’re just one step away from completing your application!`,
  btnName: `Continue`,
}

export const YOURSELF_DETAILS = {
  title: 'Tell Us About Yourself',
  description: `Answer a few questions to help us match you with the ideal program for
        your goals`,
  btnName: `Let's Go!`,
}

export const infoBatchDataSet = [
  {
    title: 'Online',
    info: 'All PW online courses including our bestselling IIT JEE & NEET courses at affordable prices',
  },
  {
    newTag: 'new',
    title: 'Power Batch',
    info: 'Premium online courses for competitive exam coaching with dedicated mentors and unlimited doubt solving',
  },
  {
    newTag: 'new',
    title: 'Offline',
    info: 'Expert-guided teaching with comprehensive resources at Vidyapeeth & Pathshala centres all over India',
  },
]

export const empCategory = (empCategory: string) => {
  if (empCategory === saathiTypeList[0]?.value) {
    return `Coaching institute name or write ‘Independent’ if self-employed`
  } else if (empCategory === saathiTypeList[1]?.value) {
    return 'Enter your School Name'
  } else if (empCategory === saathiTypeList[2]?.value) {
    return 'Enter the name of your Counselling Organisation or Institute'
  } else if (empCategory === saathiTypeList[3]?.value) {
    return `Organisation name or write ‘Independent’ if self-employed`
  } else {
    return ''
  }
}

export const filterLeadList = [
  'Last 30 Days',
  'Last Months',
  'Last 7 days',
  'Last Week',
  'Today',
  'Yesterday',
  '',
]

export const dataMap: Record<string, any> = {
  [NEW_PROGRAM_PROFILE.STUDENT]: studentDetails,
  [NEW_PROGRAM_PROFILE.BUSINESS]: businessDetails,
  [NEW_PROGRAM_PROFILE.COLLEGE]: collegeDetails,
  [NEW_PROGRAM_PROFILE.MEDICAL]: medicalDetails,
  [NEW_PROGRAM_PROFILE.UNDER_GRADUATE]: undergraduateDetails,
}

export const profileMapping: ProfileMapping = {
  [NEW_PROGRAM_PROFILE.STUDENT]: descriptionTypes,
  [NEW_PROGRAM_PROFILE.BUSINESS]: descriptionTypes,
  [NEW_PROGRAM_PROFILE.PROFESSIONAL]: descriptionTypes,
  [NEW_PROGRAM_PROFILE.SCHOOL]: studentDetails,
  [NEW_PROGRAM_PROFILE.COLLEGE]: studentDetails,
  [NEW_PROGRAM_PROFILE.MEDICAL]: collegeDetails,
  [NEW_PROGRAM_PROFILE.ENGINEERING]: collegeDetails,
  [NEW_PROGRAM_PROFILE.OTHER_FIELDS]: collegeDetails,
  [NEW_PROGRAM_PROFILE.UNDER_GRADUATE]: medicalDetails,
  [NEW_PROGRAM_PROFILE.POST_GRADUATE]: medicalDetails,
  [NEW_PROGRAM_PROFILE.SHOP_BUSINESS]: businessDetails,
  [NEW_PROGRAM_PROFILE.DIFF_BUSINESS]: businessDetails,
  [NEW_PROGRAM_PROFILE.ADVAN_MEDICAL]: undergraduateDetails,
  [NEW_PROGRAM_PROFILE.OTHER_COURSES]: undergraduateDetails,
  [NEW_PROGRAM_PROFILE.DEFAULT_DATA]: descriptionTypes,
}

export const newSublayersMapping: SublayersMapping = {
  [NEW_PROGRAM_PROFILE.STUDENT]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.BUSINESS]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.PROFESSIONAL]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.SCHOOL]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.COLLEGE]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.MEDICAL]: NEW_PROGRAM_PROFILE.COLLEGE,
  [NEW_PROGRAM_PROFILE.ENGINEERING]: NEW_PROGRAM_PROFILE.COLLEGE,
  [NEW_PROGRAM_PROFILE.OTHER_FIELDS]: NEW_PROGRAM_PROFILE.COLLEGE,
  [NEW_PROGRAM_PROFILE.UNDER_GRADUATE]: NEW_PROGRAM_PROFILE.MEDICAL,
  [NEW_PROGRAM_PROFILE.POST_GRADUATE]: NEW_PROGRAM_PROFILE.MEDICAL,
  [NEW_PROGRAM_PROFILE.SHOP_BUSINESS]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.DIFF_BUSINESS]: NEW_PROGRAM_PROFILE.STUDENT,
  [NEW_PROGRAM_PROFILE.ADVAN_MEDICAL]: NEW_PROGRAM_PROFILE.UNDER_GRADUATE,
  [NEW_PROGRAM_PROFILE.OTHER_COURSES]: NEW_PROGRAM_PROFILE.UNDER_GRADUATE,
  [NEW_PROGRAM_PROFILE.DEFAULT_DATA]: NEW_PROGRAM_PROFILE.DEFAULT_DATA,
}

export const COMMISSION_VIEW_ORGANIZATIONAl_DATA = [
  { orgName: 'PW (Coupon Sale)', orgId: '1' },
  {
    orgName: 'PW (Assisted Sale)',
    orgId: '2',
  },
]

export const COMMISSION_CALCULATION_DATA = [
  {
    title: 'Phone Number Verification',
    info: 'The mobile number used for course registration must match the number provided in lead',
    image: `${phoneImg}`
  },
  {
    title: 'Lead Conversion Timeframe',
    info: 'Course registration must be completed within 30 days of lead submission',
    image: `${calendarImg}`
  }
]

export const landingPageHeaderItemsCSC = [
  {
    name: 'Steps',
    type: LANDING_PAGE.STEPS,
  },
  {
    name: 'Our Presence',
    type: LANDING_PAGE.PRESENCE,
  },
  {
    name: 'How it Works',
    type: LANDING_PAGE.HOW_IT_WORKS,
  },
  {
    name: 'FAQ',
    type: LANDING_PAGE.FAQ,
  },
]
export const HAMBURGER_CSC = [
  { name: 'Steps', key: 'Steps' },
  { name: 'Our Presence', key: 'Presence' },
  { name: 'How it Works', key: 'how_it_works' },
  { name: 'FAQ', key: 'faq' },

]